import React from "react";

function Footer() {
  return (
    <div class="footer">
      <div class="icon-container">
        <a href="https://github.com/gaurav-iitb" target="_blank">
          <i class="fa-brands fa-github icons"></i>
        </a>
        <a href="https://www.facebook.com/profile.php?id=100047506506123" target="_blank">
          <i class="fa-brands fa-facebook icons"></i>
        </a>
        <a href="mailto:200010026@iitb.ac.in " target="_blank">
          <i class="fa-solid fa-envelope icons"></i>
        </a>
        <a href="https://www.linkedin.com/in/gaurav-sharma-93b9b0207/" target="_blank">
          <i class="fa-brands fa-linkedin icons"></i>
        </a>
      </div>
      <p class="copyright">© 2023 Gaurav Sharma, All Rights Reserved</p>
    </div>
  );
}

export default Footer;
